<template>
  <div>
    <form-item
      prop="payload_type"
      :label="$t('CampaignForm_NativeInline_Field_JsonType')"
    >
      <enum-select
        :options="payloadLabels"
        v-model="message.native.payload_type"
        data-qa="native-input-dropdown"
      />
    </form-item>
    <form-item prop="json" v-if="message.native.payload_type === 'json'">
      <key-value-editor v-model="message.native.payload.json" />
    </form-item>
    <form-item prop="raw" v-if="message.native.payload_type === 'raw'">
      <snippet-input
        type="textarea"
        class="raw-input"
        v-model="message.native.payload.raw"
        :snippets="false"
        :emoji="false"
        data-qa="native-raw-input"
      />
    </form-item>
    <inline-form
      v-if="
        message.native.payload_type === 'form' && message.native.payload.form
      "
      v-model="message.native.payload"
    />
  </div>
</template>

<script>
import EnumSelect from '@/common/components/form/EnumSelect'
import KeyValueEditor from '@/modules/campaign-manage/components/content/channels/KeyValueEditor'
import InlineForm from '@/modules/campaign-manage/components/setup/InlineForm'
import FormItem from '@/common/components/form/FormItem'
import SnippetInput from '@/modules/campaign-manage/components/SnippetInput'

export default {
  name: 'NativeInlineForm',
  components: {
    SnippetInput,
    InlineForm,
    KeyValueEditor,
    EnumSelect,
    FormItem
  },
  props: {
    message: {
      type: Object,
      required: true
    }
  },

  computed: {
    payloadLabels() {
      return {
        raw: 'CampaignForm_NativeInline_Payload_Json_Raw',
        json: 'CampaignForm_NativeInline_Payload_Json_Params',
        form: 'CampaignForm_NativeInline_Payload_Json_Form'
      }
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .raw-input textarea {
  white-space: pre;
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/content/channels/NativeInlineForm.vue